import { render } from "./Tab3.vue?vue&type=template&id=956cd896&scoped=true"
import script from "./Tab3.vue?vue&type=script&lang=js"
export * from "./Tab3.vue?vue&type=script&lang=js"

import "./Tab3.vue?vue&type=style&index=0&id=956cd896&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Desktop/supaionic/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-956cd896"]])